export const apiListSimSell = "/1.0/sell/sim/list"
export const apiListPackageSell = "/1.0/sell/package/list"
export const apiDropdownCountry = "/1.0/drop/countries/list"
export const apiDropdownNetwork = "/1.0/drop/carrier/list"

